import React from 'react';
// import './HdDialog.scss';
class HdDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            options: this.props.options
        };
    }

    //组件接收到新的props时调用，并将其作为参数nextProps使用，此时可以更改组件props及state。
    componentWillReceiveProps(nextProps) {
        if (nextProps.options.type == 'msg' || nextProps.options.type == 'success') {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.props.hideDialog();
            }, 1800)
        }
    }

    componentWillUnmount() {
        // 如果存在this.timer，则使用clearTimeout清空。
        // 如果你使用多个timer，那么用多个变量，或者用个数组来保存引用，然后逐个clear
        this.timer && clearTimeout(this.timer);
    }

    render() {

        if (this.props.options.type == 'confirm') {
            return (
                <section>
                    <div className="dialog">
                        <header className="dialog-header">{this.props.options.title}</header>
                        <div className="dialog-body">
                            <p dangerouslySetInnerHTML={{__html: this.props.options.content}}/>
                        </div>
                        <div className="dialog-operate">
                            {
                                this.props.options.cancelTxt &&
                                <button className={this.props.options.cancelClass || "cancel" }
                                        onClick={this.props.options.cancel || this.props.hideDialog.bind(this)}>
                                    {this.props.options.cancelTxt || '取消'}
                                </button>
                            }

                            <button className={this.props.options.confirmClass || "confirm"}
                                    onClick={this.props.options.confirm}>
                                {this.props.options.confirmTxt || '确定'}
                            </button>
                        </div>
                    </div>
                    <div className="dialog-mask" onClick={() => this.props.hideDialog()}/>
                </section>
            )
        } else if (this.props.options.type == 'msg') {
            return (
                <section>
                    <div className="dialog-msg">{this.props.options.content}</div>
                </section>
            )
        } else if (this.props.options.type == 'success') {
            return (<Success content={this.props.options.content}/>)
        }
        else {
            return null
        }

    }
}
module.exports = HdDialog;

//成功提示
const Success = (props) => {
    return (
        <div className="dialog-success">
            <img src={require("./../../static/images/my_account_authentication_icon_authentication_ok.png")} alt=""/>
            <p>{props.content}</p>
        </div>
    )
};


// WEBPACK FOOTER //
// ./src/components/HdDialog/HdDialog.js